import { type ConflictErrorExtensions, createApolloClient } from "@axio/graphql";

import { authClient } from "./auth/client";

const GRAPHQL_HTTP_ENDPOINT = typeof window === "undefined" ? "/api/graphql" : `${window.location.origin}/api/graphql`;
const GRAPHQL_SSE_ENDPOINT =
  typeof window === "undefined" ? "/api/graphql/stream" : `${window.location.origin}/api/graphql/stream`;

export const CONFLICT_EVENT_NAME = "axio:conflict";

export type ConflictEventDetail = ConflictErrorExtensions;

const dispatchConflict = (extensions: ConflictErrorExtensions): void => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<ConflictEventDetail>(CONFLICT_EVENT_NAME, { detail: extensions }));
};

export const apolloClient = createApolloClient({
  authClient,
  httpEndpoint: GRAPHQL_HTTP_ENDPOINT,
  sseEndpoint: GRAPHQL_SSE_ENDPOINT,
  onConflict: dispatchConflict,
});
